export default __webpack_public_path__ + "static/media/BF.37540aeb.svg";